import Vue from 'vue'
import Router from 'vue-router'

import Document from './components/Document.vue'
import RequestDemo from './views/RequestDemo.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      meta: { requiresAuth: false },
      beforeEnter (to, from, next) {
        store.dispatch('isCookieValid').then((isCookieValid) => {
          if (isCookieValid) {
            next('/')
          } else {
            next()
          }
        })
      },
      component: () => import('./views/Login.vue')
    },
    {
      path: '/demo',
      name: 'demo',
      component: RequestDemo,
      meta: { requiresAuth: false }
    },
    {
      path: '/:id?',
      name: 'document',
      component: Document,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.commit('startLoading')
    store.dispatch('isCookieValid').then((isCookieValid) => {
      store.commit('endLoading')
      if (!isCookieValid) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    })
  } else {
    next()
  }
})

export default router
